export default __webpack_public_path__ + "static/media/top-developers.45982d99.png";